import { Stack, Typography } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import { ONBOARDING_COLORS } from "../../features/organisations/onboarding/onboardingDesign.js";
import { MeisterMark } from "./MeisterMark.js";

/** The block both `/` and `/signup` open with: the mark, the welcome heading and a sub line. */
export const SignupHeading = ({ subline }: { subline: string }) => {
  const { t } = useTranslate(["PageSignup"]);

  return (
    <Stack sx={{ alignItems: "center" }}>
      <MeisterMark sx={{ height: 40, mb: "24px" }} />
      <Typography
        variant="h1"
        sx={{
          fontSize: { xs: 28, tablet: 36 },
          fontWeight: 500,
          lineHeight: 1.15,
          letterSpacing: "-0.01em",
          color: ONBOARDING_COLORS.heading,
          textAlign: "center",
        }}
      >
        {t("Welcome to Meister Systems", { ns: "PageSignup" })}
      </Typography>
      <Typography
        sx={{
          mt: "10px",
          width: "100%",
          fontSize: 16,
          lineHeight: 1.45,
          letterSpacing: "normal",
          color: ONBOARDING_COLORS.body,
          textAlign: "center",
        }}
      >
        {subline}
      </Typography>
    </Stack>
  );
};
